<template>
  <div
    class="w-full"
    v-if="latest"
  >
    <h3 class="w-full md:text-2xl text-center leading-tight dark-blue mb-1">
      {{latest.name}} {{latest.level}}m
      <i
        v-if="latest.change == 1"
        class="icon-up-bold text-3xl"
        :style="{color: latest.alert}"
      ></i>
      <i
        v-if="latest.change == -1"
        class="icon-down-bold text-3xl"
        :style="{color: latest.alert}"
      ></i>
    </h3>
    <div class="flex">
      <line-chart
        class="w-full"
        :options="chartOptions"
        @afterSetExtremes="resizeChart"
      />
    </div>
  </div>
</template>

<script>
import LineChart from "@app/components/charts/highcharts/LineChart.vue";
import { ApiPublic } from "@app/api/ApiPublic";
import Highcharts from "highcharts";
import FeatherIcon from "@app/components/FeatherIcon.vue";

export default {
  components: { LineChart, FeatherIcon },
  props: {
    device: {
      type: String,
      required: true,
    },
    height: {
      type: Number,
      default: 260,
    },
  },
  data() {
    return {
      chartOptions: {},
      chartData: [],
      latest: null,
      chart: null,
    };
  },
  computed: {},
  methods: {
    fetchData() {
      ApiPublic.get(`/preprocessed-24h?device=${this.device}`, {}).then(
        ({ data }) => {
          this.latest = data.results.latest;

          this.chartOptions = data.results.chartOptions;
          this.chartOptions.tooltip.formatter = function () {
            function toolTipUnitConversion(value, unit) {
              if (unit == "m") {
                return value + " m";
              } else if (unit == "ft") {
                value = value * 100;
                var inches = value / 2.54;
                inches = Math.floor(inches);
                var rest_inches = inches % 12;
                rest_inches = rest_inches.toFixed(0);
                var ft = Math.floor(inches / 12);

                return ft + "' " + rest_inches + "'' ";
              }
            }

            var s = Highcharts.dateFormat("%e %b, at %H:%M", new Date(this.x));

            this.points.forEach((point, i) => {
              s +=
                '<br/> <span style="color:' +
                point.series.color +
                '">\u25CF</span> ' +
                point.series.name +
                ": " +
                '<br/> <span style="color:' +
                point.series.color +
                '">\u00A0\u00A0\u00BB</span> ' +
                toolTipUnitConversion(this.y, "m") +
                '<br/> <span style="color:' +
                point.series.color +
                '">\u00A0\u00A0\u00BB</span> ' +
                toolTipUnitConversion(this.y, "ft");
            });

            return s;
          };

          this.resizeChart();
        }
      );
    },
    resizeChart(chart) {
      if (!chart) {
        return;
      }
      chart.setSize(null, this.height);
    },
  },
  created() {
    setInterval(() => {
      this.fetchData();
    }, 1000 * 60);
    this.fetchData();
  },
};
</script>

<style scoped>
.level {
  /* color: #44518c; */
}

.blue {
  color: #0006ea;
}

.red {
  color: #f00;
}

.dark-blue {
  color: #000;
}

.level-col {
  width: 120px;
}
</style>